"use client";

import { useLocale } from "use-intl";

import { CatalogPricingFaqContent } from "@/components/catalog-pricing-faq-items";
import { catalogPricingFaqModel } from "@/components/catalog-pricing-faq-model";
import type { DealOfferSummary } from "@/components/marketplace/deal-offers-types";
import { useAppDateTime } from "@/hooks/use-app-date-time";

export function CatalogPricingFaq({
  artist,
  entityType,
  releaseId,
  summary,
  title,
  workId,
}: {
  artist: string;
  entityType: "release" | "work";
  releaseId?: string;
  summary: DealOfferSummary | null | undefined;
  title: string;
  workId: string;
}) {
  const locale = useLocale();
  const { date } = useAppDateTime();

  if (!summary?.priceInsightsVisible || !hasExactPricingScope(summary, entityType, releaseId))
    return null;

  const model = catalogPricingFaqModel(summary, locale, date);
  if (!model) return null;
  return (
    <CatalogPricingFaqContent
      input={{ artist, entityType, model, releaseId, summary, title, workId }}
    />
  );
}

function hasExactPricingScope(
  summary: DealOfferSummary,
  entityType: "release" | "work",
  releaseId: string | undefined,
) {
  if (entityType === "work") return summary.summaryScopeKind === "work";
  return (
    summary.summaryScopeKind === "release" &&
    releaseId != null &&
    summary.requestedReleaseId === releaseId
  );
}
